import { helper } from '@ember/component/helper';

export const keyLength = ([object]) => Object.keys(object).length;

export default helper(keyLength);
